import { createQueryKeys } from "@lukemorales/query-key-factory";
import { CountriesApi } from "mws-ts-v2-sdk";

import { getUniversalAxios } from "~/utils/axios/getUniversalAxios";

const getCountriesApi = () => {
  return new CountriesApi(
    undefined,
    useRuntimeConfig().public.financeServiceUrl,
    getUniversalAxios(),
  );
};

export const countryQueryKeys = createQueryKeys("countries", {
  list: () => ({
    queryKey: ["all"],
    queryFn: async () => {
      const response = await getCountriesApi().v2CountriesGet();

      return response.data;
    },
  }),
});
